import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_6 = {
  key: 0,
  class: "flex-1 flex items-center justify-center"
}
const _hoisted_7 = {
  key: 1,
  class: "flex-1 flex items-center justify-center"
}
const _hoisted_8 = {
  key: 2,
  class: "flex-1"
}
const _hoisted_9 = { class: "flex items-center p-8" }
const _hoisted_10 = {
  key: 3,
  class: "flex-1 flex flex-col"
}
const _hoisted_11 = { class: "flex-1 space-y-2 mb-4" }
const _hoisted_12 = ["data-dusk"]
const _hoisted_13 = { class: "flex items-center space-x-3 min-w-0" }
const _hoisted_14 = { class: "min-w-0 h-10 flex flex-col justify-center" }
const _hoisted_15 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-gray-500 truncate"
}

import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { Domain, Organisation, PaginatedResponseMeta } from '@/models';
import { SearchInput } from '@/lib/components/Search';
import { BaseButton } from '@/lib/components/Button';
import { BasePagination } from '@/lib/components/Pagination';
import MedKitBadge from '@/lib/components/Badge/MedKitBadge.vue';
import EmptyState from '@/custom/menicon/components/EmptyState.vue';
import { LoadingIcon } from '@/lib/components/Loading';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganisationListPanel',
  props: {
  domain: {
    type: Object as PropType<Domain | null>,
    default: null
  },
  organisations: {
    type: Array as PropType<Organisation[]>,
    default: () => []
  },
  pagination: {
    type: Object as PropType<PaginatedResponseMeta | null>,
    default: null
  },
  search: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:search", "page-change", "create-child", "edit-domain", "edit-organisation"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const currentPage = computed(() => props.pagination?.current_page ?? 1);
const totalItems = computed(() => props.pagination?.total ?? 0);
const perPage = computed(() => props.pagination?.per_page ?? 10);

const handleSearchUpdate = (value: string): void => {
  emit('update:search', value);
};

const handlePageChange = (page: number): void => {
  emit('page-change', page);
};

const handleEditOrganisation = (organisationId: string): void => {
  emit('edit-organisation', organisationId);
};

const handleEditDomain = (): void => {
  emit('edit-domain');
};

const handleCreateChild = (): void => {
  emit('create-child');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.domain)
          ? (_openBlock(), _createBlock(MedKitBadge, {
              key: 0,
              class: "capitalize",
              kind: "medium",
              label: __props.domain.type === 'domain' ? 'Domain' : 'Subdomain',
              size: "small"
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.domain?.name ?? _unref(t)('platform.domain-admin.organisations.select-domain')), 1)
      ]),
      (__props.domain)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(BaseButton), {
              color: "ghost",
              size: "small",
              "left-icon": "add",
              "data-dusk": "org-new-child-btn",
              onClick: handleCreateChild
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('platform.org-unit.new-child')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseButton), {
              color: "muted",
              size: "small",
              "data-dusk": "edit-domain-btn",
              onClick: handleEditDomain
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.domain?.type === 'domain' ? _unref(t)('platform.domain-admin.domain.edit') : _unref(t)('platform.domain-admin.subdomain.edit')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(SearchInput), {
      "model-value": __props.search,
      class: "mb-4",
      placeholder: _unref(t)('platform.domain-admin.search-organisations'),
      clear: true,
      "data-dusk": "organisation-search",
      "onUpdate:modelValue": handleSearchUpdate
    }, null, 8, ["model-value", "placeholder"]),
    (!__props.domain)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(EmptyState, {
            icon: "list",
            title: _unref(t)('platform.domain-admin.organisations.select-domain')
          }, null, 8, ["title"])
        ]))
      : (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(LoadingIcon), { class: "text-gray-500" })
          ]))
        : (__props.organisations.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(EmptyState, {
                  icon: "list",
                  title: __props.search ? _unref(t)('platform.common.table-no-results') : _unref(t)('platform.domain-admin.organisations.no-organisations')
                }, null, 8, ["title"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.organisations, (org) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: org.id,
                    class: _normalizeClass(["flex items-center justify-between bg-white border border-gray-300 rounded-lg shadow-sm px-4 py-3 hover:bg-gray-50 transition-colors", { 'bg-gray-100 text-gray-500': !org.is_active }]),
                    "data-dusk": `org-item-${org.id}`
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(MedKitBadge, {
                        kind: "low",
                        label: _unref(t)('platform.domain-admin.organisations.name'),
                        size: "small"
                      }, null, 8, ["label"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(org.name), 1),
                        (org.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(org.description), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode(_unref(BaseButton), {
                      color: "muted",
                      size: "small",
                      "data-dusk": "org-edit-btn",
                      onClick: ($event: any) => (handleEditOrganisation(org.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('platform.common.edit')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 10, _hoisted_12))
                }), 128))
              ]),
              (__props.pagination && totalItems.value > perPage.value)
                ? (_openBlock(), _createBlock(_unref(BasePagination), {
                    key: 0,
                    "model-value": currentPage.value,
                    "page-size": perPage.value,
                    length: totalItems.value,
                    "items-name": _unref(t)('platform.domain-admin.organisations.name'),
                    "onUpdate:modelValue": handlePageChange
                  }, null, 8, ["model-value", "page-size", "length", "items-name"]))
                : _createCommentVNode("", true)
            ]))
  ]))
}
}

})